module.exports = __webpack_public_path__ + "static/IMG_5882-94cd654cfaccd2ddb01ec014eefa4ac9.jpg";